export const WidgetType = {
    Match: 'match',
    Market: 'market',
    Superbets: 'superbets',
} as const;
export type WidgetType = typeof WidgetType[keyof typeof WidgetType];

export type WidgetDto =
    | MatchWidget
    | MarketWidget
    | SuperbetsWidget
    ;

type MatchWidget = {
    type: typeof WidgetType.Match;
    superbetMatchId: string;
};

type MarketWidget = {
    type: typeof WidgetType.Market;
    superbetMatchId: string;
    superbetMarketId: string;
};

type SuperbetsWidget = {
    type: typeof WidgetType.Superbets;
    superbetMatchId: string;
};
